/* eslint-disable */
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface SubscriptionsApiParameter extends ApiParameter {
    productId: string;
    subscribed: boolean;
}

const subscriptionsUrl = "api/v1/ProductSubscriptions";

export type SubscriptionResult = {
    productId: string;
    subscribed: boolean;
};

// eslint-disable-next-line require-await
export async function getProductSubscriptionWithResult(parameter: string): Promise<ServiceResult<string>> {
    return get<any>(`${subscriptionsUrl}/GetSubscriptionStatus?productErpNumber=${parameter}`, {} as ApiParameter);
}

export async function updateSubscriptionWithResult(
    parameter: SubscriptionsApiParameter,
): Promise<ServiceResult<SubscriptionResult>> {
    if (parameter.subscribed) {
        try {
            const subscriptionModel = await post<any>(
                `${subscriptionsUrl}/CreateProductSubscription?productErpNumber=${parameter.productId}`,
                {},
            );
            return {
                successful: true,
                result: subscriptionModel,
            };
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                return {
                    successful: false,
                    errorMessage: error.errorJson.message,
                };
            }
            throw error;
        }
    } else {
        try {
            const subscriptionModel = await post<any>(
                `${subscriptionsUrl}/DeleteProductSubscription?productErpNumber=${parameter.productId}`,
                {},
            );
            const result = { productId: parameter.productId, subscribed: false };
            return {
                successful: true,
                result,
            };
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                return {
                    successful: false,
                    errorMessage: error.errorJson.message,
                };
            }
            throw error;
        }
    }
}
